import { useEffect, useRef } from 'react'
import { DeviceOrientationAR } from '@/services/xr/device-orientation-ar'

interface ARCameraBackgroundProps {
  deviceOrientationAR: DeviceOrientationAR | null
  className?: string
}

export function ARCameraBackground({ deviceOrientationAR, className = '' }: ARCameraBackgroundProps) {
  const videoRef = useRef<HTMLVideoElement>(null)
  
  useEffect(() => {
    if (!deviceOrientationAR || !videoRef.current) return
    
    const video = deviceOrientationAR.getVideoElement()
    if (!video) {
      console.warn('No video element from DeviceOrientationAR')
      return
    }
    
    // Clone video element to display in background
    const stream = video.srcObject as MediaStream
    if (stream) {
      videoRef.current.srcObject = stream
      
      // Ensure video plays
      videoRef.current.play().catch(err => {
        console.error('Failed to play AR camera video:', err)
      })
    } else {
      console.warn('No media stream available from AR video element')
    }
  }, [deviceOrientationAR])
  
  if (!deviceOrientationAR) return null
  
  return (
    <video
      ref={videoRef}
      className={`absolute inset-0 w-full h-full object-cover ${className}`}
      autoPlay
      playsInline
      muted
      style={{ 
        transform: 'scaleX(-1)', // Mirror for selfie camera
        zIndex: -1, // Ensure it's behind the canvas
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover'
      }}
    />
  )
}